<template>
  <div class="trash-list__item">
    <div>{{ itemText.name }}</div>
    <div>
      <BaseButton v-if="!currentUserIsWatcher"
                  theme="white-red" size="xs"
                  :loading="submitted"
                  @click="restore">
        {{ $t('restore') }}
      </BaseButton>
    </div>
  </div>
</template>

<script>
import BaseButton from "@/components/UI/BaseButton";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "TrashListItem",
  components: {BaseButton},
  props: {
    item: {
      type: Object
    },
    type: {
      type: String
    }
  },
  data() {
    return {
      submitted: false
    }
  },
  computed: {
    ...mapGetters('cabinet/currencies', ['displayCurrencyValue']),
    ...mapGetters('space', ['currentUserIsWatcher']),
    itemText() {
      let name = this.getItemName(),
          type = this.$t(`typeLabels.${this.type}`);
      return {name, type};
    }
  },
  methods: {
    ...mapActions('space/trash', ['restoreItem']),
    getItemName() {
      switch (this.type) {
        case 'accounts':
        case 'expenseCategories':
        case 'incomeSources':
        case 'contractors':
          return this.item.title;
        case 'transactions':
          let date = this.$moment.unix(this.item.created_at).format('DD.MM.YYYY'),
              type = this.item.type === 1 ? this.$t('transactionTypeIncome') : this.$t('transactionTypeExpense'),
              sum = this.displayCurrencyValue(this.item.sum, this.item.account.currency);
          return `${date} ${type} ${sum}`
        default:
          return '';
      }
    },
    async restore() {

      try {
        const restoreData = {id: this.item.id, modelType: this.type};
        const res = await this.restoreItem(restoreData);
        if (res.body.success) {
          //declination - склонение для русского языка
          let declination = ['accounts', 'incomeSources', 'contractors'].includes(this.type),
              declinationMessage = `${this.$t(`restoredText${declination ? 'M' : 'W'}`)}.`,
              successMessage = `${this.itemText.type} "${this.itemText.name}" ${declinationMessage}`;

          this.$toasted.success(successMessage);
          this.$emit('restored');
        } else {
          this.$toasted.error('Ошибка');
          console.error(res.body);
        }
      } catch (err) {
        this.$toasted.error('Ошибка');
        console.error(err);
      }
    }
  },
  i18n: {
    messages: {
      en: {
        transactionTypeIncome: 'Income',
        transactionTypeExpense: 'Expense',
        typeLabels: {
          transactions: 'Transaction',
          accounts: 'Account',
          expenseCategories: 'Expense category',
          incomeSources: 'Income source',
          contractors: 'Contractor',
        },
        restore: 'Restore',
        restoredTextW: 'moved from trash',
        restoredTextM: 'moved from trash'
      },
      ru: {
        transactionTypeIncome: 'Доход',
        transactionTypeExpense: 'Расход',
        typeLabels: {
          transactions: 'Операция',
          accounts: 'Счет',
          expenseCategories: 'Категория расхода',
          incomeSources: 'Источник дохода',
          contractors: 'Контрагент',
        },
        restore: 'Восстановить',
        restoredTextW: 'восстановлена из корзины',
        restoredTextM: 'восстановлен из корзины',
      },
    }
  }
}
</script>